import {
  ShineStartDocument,
  ShineStartDocumentStatus,
} from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import getShineStartDocumentLabel from 'features/Onboarding/modules/ShineStartVerification/libs/getShineStartDocumentLabel';

import getDocumentStatus from '../../libs/getDocumentStatus';
import locales from './locales';
import { DocsProblemWrapper } from './styles';

interface HomeProps {
  onNext: () => void;
  documents: ShineStartDocument[];
  onDocumentClick: (documentId: string) => void;
}
const Home = asBentoPage<HomeProps>(
  ({ documents, Layout, onDocumentClick, onNext, onPrev }) => {
    const hasRefusedDocument = documents.some(
      (doc) => doc.status === ShineStartDocumentStatus.Refused,
    );

    return (
      <>
        <Layout nav={<OBNavigation onPrev={onPrev} />}>
          <Header
            description={locales.headerDescription}
            title={locales.title}
          />

          {hasRefusedDocument ? (
            <DocsProblemWrapper>
              <Text fontWeight="weight-500" variant="primary">
                {locales.problemWithDocs}
              </Text>
            </DocsProblemWrapper>
          ) : null}

          <SunshineCard.Group isBoxed={false} marginBottom="space-40">
            {documents.map((document) => {
              const { shineStartDocumentId, status } = document;
              const documentStatus = getDocumentStatus(status);

              const renderIcon = () => {
                if (documentStatus === 'waiting') {
                  return <SquircleIcon name="file" />;
                }

                if (documentStatus === 'error') {
                  return <SquircleIcon colorScheme="red" name="cross" />;
                }

                return <SquircleIcon colorScheme="green" name="tick" />;
              };

              return (
                <SunshineCard
                  alignItems="center"
                  isDisabled={documentStatus === 'complete'}
                  key={shineStartDocumentId}
                  onClick={() => onDocumentClick(shineStartDocumentId)}
                  title={getShineStartDocumentLabel(document)}
                >
                  <SunshineCard.Slot name="aside">
                    {renderIcon()}
                  </SunshineCard.Slot>

                  <SunshineCard.Slot name="action">
                    <SunshineCard.SunshineIcon name="chevron-right" />
                  </SunshineCard.Slot>
                </SunshineCard>
              );
            })}
          </SunshineCard.Group>

          <Button alignSelf="center" isExpanded onClick={onNext}>
            {locales.cta}
          </Button>
        </Layout>
      </>
    );
  },
);

export default Home;
